export const extensionRoutes = [  {
    path: 'extensions/drip-campaigns',
    loadChildren: () => import('./extensions/drip-campaing-ui/routes'),
  },
  {
    path: 'extensions/product-reviews',
    loadChildren: () => import('./extensions/d16ec93d053714e697ac1a0f713119261ff673d945fb8a3bc47d67b1e87ba82a/reviews-ui-lazy.module').then(m => m.ReviewsUiLazyModule),
  },
  {
    path: 'extensions/page',
    loadChildren: () => import('./extensions/pages/pages-ui-lazy.module').then(m => m.PagesLazyModule),
  },
  {
    path: 'extensions/feedbacks',
    loadChildren: () => import('./extensions/feedback/route'),
  },
  {
    path: 'extensions/analytics',
    loadChildren: () => import('./extensions/analytics/route'),
  },
  {
    path: 'settings',
    loadChildren: () => import('./extensions/positouch-ui/routes'),
  },
  {
    path: 'extensions/doordash',
    loadChildren: () => import('./extensions/doordash-ui/routes'),
  },
  {
    path: 'orders',
    loadChildren: () => import('./extensions/4ab2a72d53837fea220edda1367fad3695706206a759828698294ec63ed2878d/routes'),
  },
  {
    path: 'extensions/customers-list',
    loadChildren: () => import('./extensions/customer-apis-ui/routes'),
  },
  {
    path: 'extensions/export-orders',
    loadChildren: () => import('./extensions/09b5125789f6be4f2457c84de4da770cdd59dfd3fb3278f34ae4772e04284b05/order-export.module').then(m => m.OrderExportModule),
  },
  {
    path: 'extensions/export-orders',
    loadChildren: () => import('./extensions/09b5125789f6be4f2457c84de4da770cdd59dfd3fb3278f34ae4772e04284b05/routes'),
  },
  {
    path: 'extensions/sales/holiday-orders',
    loadChildren: () => import('./extensions/holiday-order-ui/routes'),
  },
  {
    path: 'extensions/sales',
    loadChildren: () => import('./extensions/catering-order-ui/routes'),
  },
  {
    path: 'extensions/sales',
    loadChildren: () => import('./extensions/pos-order-ui/routes'),
  },
  {
    path: 'extensions/sales',
    loadChildren: () => import('./extensions/uber-eats-order-ui/routes'),
  },
  {
    path: 'extensions/coupon-codes',
    loadChildren: () => import('./extensions/coupon-codes-ui/routes'),
  },
  {
    path: 'extensions/deals',
    loadChildren: () => import('./extensions/deals-ui/routes'),
  },
  {
    path: 'extensions/time-slots',
    loadChildren: () => import('./extensions/time-slots-ui/routes'),
  },
  {
    path: 'extensions/loyalty-variants',
    loadChildren: () => import('./extensions/product-enabilities/route'),
  },
  {
    path: 'extensions/spin-promos',
    loadChildren: () => import('./extensions/spin-rewards/route'),
  },
  {
    path: 'extensions/scratch-promos',
    loadChildren: () => import('./extensions/scratch-rewards/route'),
  },
  {
    path: 'extensions/careers',
    loadChildren: () => import('./extensions/career-ui/routes'),
  },
  {
    path: 'extensions/app-reviews',
    loadChildren: () => import('./extensions/app-reviews-ui/routes'),
  },
  {
    path: 'extensions/sales',
    loadChildren: () => import('./extensions/clover-pos-ui/routes'),
  }];
